import { PreviewText } from 'owa-locstrings/lib/strings/previewtext.locstring.json';
import loc from 'owa-localize';
import { previewSharePointDocumentLinkInSxS } from '../../actions/publicActions';
import { closeLinkContextMenu } from '../../components/LinkContextMenu';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';

import {
    lazyForceGetWacInfoOperation,
    lazyGetValidDocLinkPreviewInfo,
} from 'owa-doc-link-click-handler';

export function getLinkPreviewContextMenuItem(
    linkUrl: string,
    linkId: string,
    isCalendar: boolean
): IContextualMenuItem | null {
    if (isCalendar) {
        return null;
    }

    return {
        name: loc(PreviewText),
        key: 'Preview',
        onClick: () => {
            previewLinkInSxS(linkUrl, linkId);
            closeLinkContextMenu();
        },
    };
}

async function previewLinkInSxS(linkUrl: string, linkId: string) {
    logUsage('PreviewLinkInSxS');
    const getValidDocLinkPreviewInfo = await lazyGetValidDocLinkPreviewInfo.import();
    let docLinkPreviewInfo = getValidDocLinkPreviewInfo(linkUrl);
    if (!docLinkPreviewInfo) {
        // this means the getWacInfo operation succeeded more than 5 minutes ago
        // force a getWacInfo call to ensure the preview info is valid (not expired)
        const forceGetWacInfoOperation = await lazyForceGetWacInfoOperation.import();
        docLinkPreviewInfo = await forceGetWacInfoOperation(
            linkUrl,
            true /* shouldReturnDocLinkPreviewInfo */
        );
    }

    previewSharePointDocumentLinkInSxS(
        () => Promise.resolve(docLinkPreviewInfo.wacUrlInfo),
        linkId,
        docLinkPreviewInfo.wacUrlInfo.readOnly
    );
}
